
import hoverintent from 'hoverintent';
export default class AccordionImages {
	constructor() {
		console.log('%c👍🏼 Accordion Images', 'color: yellow');           
		this.accordionImages = document.querySelectorAll('.events-accordion');
    }
    init() {
       
        this.accordionImages.forEach(accordionImage => {
            const singleImg = accordionImage.querySelector('.events-accordion__img-wrapper img');
            const accordion = accordionImage.querySelector('.accordion');
            const accordionItems = accordionImage.querySelectorAll('.accordion-item');

            accordionItems.forEach(accordionItem => {
                hoverintent(accordionItem, function() {
                    const activeAccordionItem = accordionImage.querySelector('.events-accordion__img-wrapper img.active');
                    if(activeAccordionItem) {
                        // console.log('active acc', activeAccordionItem);
                        activeAccordionItem.classList.remove('active');
                        // activeAccordionItem.style.top = '0px';
                       
                        setTimeout(() => {
                            activeAccordionItem.style.top = '0px';
                        }, 350);
                    }

                   
                    // const accordionRect = accordion.getBoundingClientRect();
                    // const itemRect = this.getBoundingClientRect();
                    const panelImgSrc = this.querySelector('img').getAttribute('src');
                    
                    setTimeout(() => {
                        singleImg.classList.add('active')
                        singleImg.setAttribute('src', panelImgSrc);
                        // const top = itemRect.top - accordionRect.top + 20;
                        // singleImg.style.top = top + 'px';
                        singleImg.style.top = 'auto';
                    }, 350);
                });
            });
        });
    }
}